import { CorporateAccountSettings } from './Components/AccountSettings'
const Settings = () => {
  return (
    <div className='py-2 flex space-x-2'>
      <div className='flex-1 bg-white p-10 rounded-lg'>
        <CorporateAccountSettings />
      </div>
    </div>
  )
}

export default Settings;
